import React from 'react';
import { Tab, TabController, Tabs } from '@one-thd/sui-atomic-components';
import QuotesTabPanels from './QuotesTabPanels';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesTabsView = () => {
  const {
    selectedTab,
    setSelectedTab,
    activeQuotes,
    expiredQuotes,
    isMobile,
    componentId
  } = useQuoteContext();

  const selectedTabOnChange = (_event, newValue) => {
    triggerAnalyticsCustomEvent('quotes.interaction-click', {
      id: componentId,
      component: `${newValue} quotes tab`,
    });
    setSelectedTab(newValue);
  };

  return (
    <TabController value={selectedTab}>
      {/* Column so the panels get the height left under the tab bar, not all of it. */}
      <div className="sui-flex sui-flex-col sui-h-full">
        <Tabs
          value={selectedTab}
          onChange={selectedTabOnChange}
          aria-label="Quotes status tabs"
          variant={isMobile ? 'fullWidth' : 'standard'}
        >
          <Tab label={`Active (${activeQuotes?.length})`} value="active" />
          <Tab label={`Expired (${expiredQuotes?.length})`} value="expired" />
        </Tabs>
        <QuotesTabPanels />
      </div>
    </TabController>
  );
};

export default QuotesTabsView;
